import React from 'react';
import styles from './actSlotAdd.module.css';

const ExistingSlots = ({
    templates = [],
    existingDateSlots = [],
    selectedTemplateKeys = new Set(),
    onToggle,
    slotExists = false
}) => {
    if (!templates.length) {
        return null;
    }

    const templateKey = (template) => `${template.startTime}-${template.endTime}`;
    console.log(existingDateSlots);
    return (
        <div className={styles.templateSlotsSection}>
            <label className={styles.sectionTitle}>
                {slotExists ? 'Slots for this date' : 'Select from existing slots'}
            </label>

            <div className={styles.templateSlotsList}>
                {templates.map((template) => {
                    const key = templateKey(template);

                    // Check whether THIS template
                    // already exists for the selected date
                    const isAlreadyExisting = existingDateSlots.some(
                        (slot) => slot.startTime === template.startTime && slot.endTime === template.endTime
                    );

                    const isSelected = selectedTemplateKeys.has(key);

                    return (
                        <button
                            type='button'
                            key={key}
                            disabled={isAlreadyExisting}
                            className={`${styles.templateSlotChip} ${
                                isSelected ? styles.templateSlotChipSelected : ''
                            } ${isAlreadyExisting ? styles.templateSlotChipDisabled : ''}`}
                            onClick={() => onToggle(template)}
                        >
                            <span>
                                {template.startTime}
                                {' – '}
                                {template.endTime}
                            </span>

                            {isAlreadyExisting && <span className={styles.slotLock}>✓</span>}

                            {!isAlreadyExisting && isSelected && <span className={styles.slotCheck}>✓</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ExistingSlots;
